module.exports = __webpack_public_path__ + "assets/tool.c8148520.svg";